import { render } from "./InputTag.vue?vue&type=template&id=85500e02&scoped=true&ts=true"
import script from "./InputTag.vue?vue&type=script&lang=ts"
export * from "./InputTag.vue?vue&type=script&lang=ts"

import "./InputTag.vue?vue&type=style&index=0&id=85500e02&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85500e02"]])

export default __exports__